// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n*::-webkit-scrollbar {\r\n  /*滚动条整体样式*/\r\n  width: 5px;\r\n  height: 5px;\n}\n*::-webkit-scrollbar :hover{\r\n  /*滚动条整体样式*/\r\n  width: 5px;\r\n  height: 5px;\n}\n*::-webkit-scrollbar-thumb {\r\n  /*滚动条里面小方块*/\r\n  border-radius: 5px;\r\n  height: 10px;\r\n  background: #9b9b9b;\n}\n*::-webkit-scrollbar-track {\r\n  /*滚动条里面轨道*/\r\n  border-radius: 5px;\r\n  background: #ededed;\n}\r\n", ""]);
// Exports
module.exports = exports;
